module.exports = __webpack_public_path__ + "static/media/img-3.810cc8a0.png";